import * as React from 'react';
import { IconProps } from '../../dto/Interfaces/IIconProps';

const PasswordExpired: React.FC<IconProps> = () => {
  return (
    <svg width="150" height="154" viewBox="0 0 150 154" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M75 150.65C116.421 150.65 150 117.072 150 75.6504C150 34.229 116.421 0.650391 75 0.650391C33.5786 0.650391 0 34.229 0 75.6504C0 117.072 33.5786 150.65 75 150.65Z"
        fill="#EAECF0"
      />
      <g filter="url(#filter0_d_9587_32890)">
        <mask id="mask0_9587_32890" maskUnits="userSpaceOnUse" x="0" y="0" width="150" height="151">
          <path
            d="M75 150.65C116.421 150.65 150 117.072 150 75.6504C150 34.229 116.421 0.650391 75 0.650391C33.5786 0.650391 0 34.229 0 75.6504C0 117.072 33.5786 150.65 75 150.65Z"
            fill="#EAECF0"
          />
        </mask>
        <g mask="url(#mask0_9587_32890)">
          <path
            d="M118 43.6504H32C29.2386 43.6504 27 45.889 27 48.6504V153.65C27 156.412 29.2386 158.65 32 158.65H118C120.761 158.65 123 156.412 123 153.65V48.6504C123 45.889 120.761 43.6504 118 43.6504Z"
            fill="white"
          />
        </g>
      </g>
      <path
        d="M66 53.6504H40C38.3431 53.6504 37 54.9935 37 56.6504C37 58.3072 38.3431 59.6504 40 59.6504H66C67.6569 59.6504 69 58.3072 69 56.6504C69 54.9935 67.6569 53.6504 66 53.6504Z"
        fill="#EAECF0"
      />
      <path
        d="M66 95.6504H40C38.3431 95.6504 37 96.9935 37 98.6504C37 100.307 38.3431 101.65 40 101.65H66C67.6569 101.65 69 100.307 69 98.6504C69 96.9935 67.6569 95.6504 66 95.6504Z"
        fill="#EAECF0"
      />
      <path
        d="M108 68.6504H42C39.7909 68.6504 38 70.4413 38 72.6504V82.6504C38 84.8595 39.7909 86.6504 42 86.6504H108C110.209 86.6504 112 84.8595 112 82.6504V72.6504C112 70.4413 110.209 68.6504 108 68.6504Z"
        stroke="#98A2B3"
      />
      <path
        d="M55.4688 81.1406H56.8066L56.6992 78.6504L58.7598 79.9492L59.4238 78.9141L57.1582 77.7129L59.4238 76.5215L58.7598 75.4863L56.6992 76.7852L56.8066 74.2949H55.4688L55.5762 76.7949L53.5059 75.4863L52.8418 76.5215L55.1074 77.7129L52.8418 78.9141L53.5059 79.9492L55.5762 78.6406L55.4688 81.1406ZM64.9023 81.1406H66.2402L66.1328 78.6504L68.1934 79.9492L68.8574 78.9141L66.5918 77.7129L68.8574 76.5215L68.1934 75.4863L66.1328 76.7852L66.2402 74.2949H64.9023L65.0098 76.7949L62.9395 75.4863L62.2754 76.5215L64.541 77.7129L62.2754 78.9141L62.9395 79.9492L65.0098 78.6406L64.9023 81.1406ZM74.3359 81.1406H75.6738L75.5664 78.6504L77.627 79.9492L78.291 78.9141L76.0254 77.7129L78.291 76.5215L77.627 75.4863L75.5664 76.7852L75.6738 74.2949H74.3359L74.4434 76.7949L72.373 75.4863L71.709 76.5215L73.9746 77.7129L71.709 78.9141L72.373 79.9492L74.4434 78.6406L74.3359 81.1406ZM83.7695 81.1406H85.1074L85 78.6504L87.0605 79.9492L87.7246 78.9141L85.459 77.7129L87.7246 76.5215L87.0605 75.4863L85 76.7852L85.1074 74.2949H83.7695L83.877 76.7949L81.8066 75.4863L81.1426 76.5215L83.4082 77.7129L81.1426 78.9141L81.8066 79.9492L83.877 78.6406L83.7695 81.1406ZM93.2031 81.1406H94.541L94.4336 78.6504L96.4941 79.9492L97.1582 78.9141L94.8926 77.7129L97.1582 76.5215L96.4941 75.4863L94.4336 76.7852L94.541 74.2949H93.2031L93.3105 76.7949L91.2402 75.4863L90.5762 76.5215L92.8418 77.7129L90.5762 78.9141L91.2402 79.9492L93.3105 78.6406L93.2031 81.1406Z"
        fill="#98A2B3"
      />
      <path
        d="M108 109.65H42C39.2386 109.65 37 111.889 37 114.65V122.65C37 125.412 39.2386 127.65 42 127.65H108C110.761 127.65 113 125.412 113 122.65V114.65C113 111.889 110.761 109.65 108 109.65Z"
        fill="#98A2B3"
      />
      <g clipPath="url(#clip0_9587_32890)">
        <path
          d="M83.3337 19.2002L79.5003 15.9502L78.417 17.2002L82.2503 20.4502L83.3337 19.2002ZM71.5837 17.2835L70.5003 16.0335L66.667 19.2002L67.7503 20.4502L71.5837 17.2835ZM75.417 21.1169H74.167V26.1169L78.0837 28.5335L78.7503 27.5335L75.417 25.5335V21.1169ZM75.0003 17.7835C70.8337 17.7835 67.5003 21.1169 67.5003 25.2835C67.5003 29.4502 70.8337 32.7835 75.0003 32.7835C79.167 32.7835 82.5003 29.4502 82.5003 25.2835C82.5003 21.1169 79.167 17.7835 75.0003 17.7835ZM75.0003 31.1169C71.7503 31.1169 69.167 28.5335 69.167 25.2835C69.167 22.0335 71.7503 19.4502 75.0003 19.4502C78.2503 19.4502 80.8337 22.0335 80.8337 25.2835C80.8337 28.5335 78.2503 31.1169 75.0003 31.1169Z"
          fill="#98A2B3"
        />
      </g>
      <path d="M118 84.6504H140L129 65.6504L118 84.6504ZM130 81.6504H128V79.6504H130V81.6504ZM130 77.6504H128V73.6504H130V77.6504Z" fill="#FFB547" />
      <defs>
        <filter id="filter0_d_9587_32890" x="21" y="34.6504" width="108" height="119" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="-3" />
          <feGaussianBlur stdDeviation="3" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_9587_32890" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_9587_32890" result="shape" />
        </filter>
        <clipPath id="clip0_9587_32890">
          <rect x="65" y="14.4502" width="20" height="20" rx="10" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PasswordExpired;
